import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSectionFormType } from '../../../../Features/storefrontSlice';
import AboutThreeLogo from '../../../../Assets/StorefrontIcons/AboutThreeLogo.svg';

function AboutThree() {
    const dispatch = useDispatch();

    const viewType = useSelector((state) => state.storefront.viewType);

    function handleClick() {
        dispatch(setSectionFormType(`ABOUT_THREE${viewType === 'MOBILE' ? '' : '_DESKTOP'}`));
    }

    return (
        <button onClick={handleClick} className="p-[10px] border border-[#EAEAEA] flex flex-col items-center gap-2 rounded-2xl outline-none select-none">
            <div className="w-full h-[100px] flex gap-2 rounded-md bg-[#EAEAEA]">
                <div className="size-full object-cover">
                    <img className='size-full object-cover' src={AboutThreeLogo} alt="" />
                </div>
            </div>

            <p className='font-medium text-[12px] leading-5 text-[#121212]'>About 3</p>
        </button>
    );
}

export default AboutThree;
